import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=7c88be9a&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c88be9a')) {
      api.createRecord('7c88be9a', component.options)
    } else {
      api.reload('7c88be9a', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=7c88be9a&", function () {
      api.rerender('7c88be9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8C5fXYXnf7g1o/JS/comp/starrating.vue"
export default component.exports